// import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';

import Navbar from './components/Navbar';
import Home from './components/Home';

 import Banner from './components/Banner';
 import Meet from './components/Meet';
 import OurService from './components/OurService';
 import Molding from './components/Molding';
 import Specialized from './components/Specialized';
 import Reqprodcte from './components/Reqprodcte';
 import Partservice from './components/Partservice';
//  import Maintance from './components/Maintance';
 import Footer from './components/Footer';
//  import Apply from './components/Apply';
import Genestandardinjtmolding from './components/Generalseries/BJinjectionmo/Genestandardinjtmolding';
import Genekii from './components/Generalseries/Kiigeneral/Genekii';
import Dpseriest from './components/Generalseries/dp-seriestwopl/Dpseriest';
import Allelectricinj from './components/Generalseries/All-Electricinjection/Allelectricinj';
import Hybridinjectsers from './components/Generalseries/Speed-Hybrid/Hybridinjectsers';
import Rotaryinjectionibm from './components/Generalseries/IBM-Rotary/Rotaryinjectionibm';

//product
import Petperforminje from './components/Productspecialized/PETpreforminjection/Petperforminje';
import Pvcfittinginjctinjec from './components/Productspecialized/PVCFittinginjct/Pvcfittinginjctinjec';
import KFSeriesthi from './components/Productspecialized/KFSeriesthinwall/KFSeriesthi';
import Keseriesmedical from './components/Productspecialized/KESeriesmedicalinstrument/Keseriesmedical';
import Bjmseries from './components/Productspecialized/BJMSeriestwocolor/Bjmseries';
import Fbseriesplast from './components/Productspecialized/FBSeriesplasticcrates/Fbseriesplast';
import Mpseriesp from './components/Productspecialized/MPSeriesphonecasesinj/Mpseriesp';
import Pbseriesph from './components/Productspecialized/PBSeriesplasticbuckets/Pbseriesph';
import Tseriesbak from './components/Productspecialized/TSeriesbakeliteinje/Tseriesbak';
import Siseriessilicon from './components/Productspecialized/SISeriessiliconeinjection/Siseriessilicon';

// Blow Molding Machine
// EB Series – Extrusion Blow Molding Machine
import Ebseriesextrusion from './components/Blowmoldingmachine/EBSeriesextrusionblow/Ebseriesextrusion';
//solution
// Palletinjectionmolding
import Palletinjectonmol from './components/Solutions/Palletinjectionmolding/Palletinjectonmol';
// Disposableplastic
import Dishposabl from './components/Solutions/Disposableplastic/Dishposabl';
//  Plasticbackpacksprayer 
import Plasticbackspray from './components/Solutions/Plasticbackpacksprayer/Plasticbackspray';
// LEDBulbmachine
import Ledbulmachi from './components/Solutions/LEDBulbmachine/Ledbulmachi';
// Plasticstoragebox
import Plasticstorbox from './components/Solutions/Plasticstoragebox/Plasticstorbox';
// Cavitypetpreforms
import Cavitypetprefor from './components/Blog/Cavitypetpreforms/Cavitypetprefor';
// Choosepetprefor
import Choosepetprefo from './components/Blog/Choosepetprefor/Choosepetprefo';
// Thecommontypet
import Thecommontyp from './components/Blog/Thecommontypet/Thecommontyp';
// Gallonbottlecaps
import Gallonbottleca from './components/Blog/Gallonbottlecaps/Gallonbottleca';
// InjePlasticbottlecaps
import InjePlasticbottlec from './components/Blog/InjePlasticbottlecaps/InjePlasticbottlec';
// Chooseplasticbottleca
import Chooseplasticb from './components/Blog/Chooseplasticbottleca/Chooseplasticb';
// Howplasticfliptop 
import Howplasticflipt from './components/Blog/Howplasticfliptop/Howplasticflipt';
// Plasticbottlehandle 
import Plasticbottlehand from './components/Blog/Plasticbottlehandle/Plasticbottlehand';
// Startanledbulb
import Startanledbu from './components/Blog/Startanledbulb/Startanledbu';
// Commonshapesbulbs
import Commonshapesbul from './components/Blog/Commonshapesbulbs/Commonshapesbul';
//  Materialsledlight 
import Materialsledlig from './components/Blog/Materialsledlight/Materialsledlig';
//Rightplasticpallet 
import Rightplasticpal from './components/Blog/Rightplasticpallet/Rightplasticpal';
// Whatstandardsplastic
import Whatstandardspla from './components/Blog/Whatstandardsplastic/Whatstandardspla';
// Commontypesplasticpallets
import Commontypesplasticpa from './components/Blog/Commontypesplasticpallets/Commontypesplasticpa';
// Commonmanufacturing
import Commonmanufact from './components/Blog/Commonmanufacturing/Commonmanufact';

// Advantagesplastic
import Advantagesps from './components/Blog/Advantagesplastic/Advantagesps';
// Thinwalleddisposabl 
import Thinwalleddisp from './components/Blog/Thinwalleddisposabl/Thinwalleddisp';
// Mixedplasticbuckets
import Mixedplasticbuc from './components/Blog/Mixedplasticbuckets/Mixedplasticbuc';
// Pvcmaterialproducts 
import Pvcmaterialpro from './components/Blog/Pvcmaterialproducts/Pvcmaterialpro';
// Extrusionblowmoldings
import Extrusionblowmol from './components/Blog/Extrusionblowmoldings/Extrusionblowmol';
// Moldingexhibition
import Moldingexhibit from './components/Blog/Moldingexhibition/Moldingexhibit';
// Whoarewe
import Contacts from './components/Contact/Contacts';


function App() {
    useEffect(() => {
    AOS.init({
      offset: 300,   //  tumne bola tha 120
      duration: 1000, //  smooth animation speed
    });  }, []);
    
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={
          <>
            <Banner />
            <Meet />
            <OurService />
            <Molding />
            <Specialized />
             <Reqprodcte /> 
            <Partservice />
            {/* <Maintance /> */}
            {/* <Apply />  */}

          </>
        } />
                <Route path="/Home" element={<Home />} />
        <Route path="/Reqprodcte" element={<Reqprodcte />} />
        <Route path="/bj-series-standard" element={<Genestandardinjtmolding />} />
        <Route path="/kii-series" element={<Genekii />} />
        <Route path="/Dp-seriest" element={<Dpseriest />} />
        <Route path="/All-electricinj" element={<Allelectricinj />} />
        <Route path="/Hybrid-injectsrs" element={<Hybridinjectsers />} />
        <Route path="/Rotary-injectionibm" element={<Rotaryinjectionibm />} />
        <Route path="/Pet-performinje" element={<Petperforminje />} />
        <Route path="/Pvc-fittinginjctinjec" element={<Pvcfittinginjctinjec />} />
        <Route path="/KF-Seriesthi" element={<KFSeriesthi />} />
        <Route path="/KES-eriesmedical" element={<Keseriesmedical />} />
        <Route path="/BJM-series" element={<Bjmseries />} />
        <Route path="/FB-seriesplast" element={<Fbseriesplast />} />
        <Route path="/MP-seriesp" element={<Mpseriesp />} />
        <Route path="/PB-seriesph" element={<Pbseriesph />} />
        <Route path="/T-seriesbak" element={<Tseriesbak />} />
        <Route path="/SI-seriessilicon" element={<Siseriessilicon />} />
        {/* Blow Molding Machine */}
        <Route path="/Eb-seriesextrusion" element={<Ebseriesextrusion />} />
        {/* Solutions */}
        <Route path="/Dishposabl" element={<Dishposabl />} />
        <Route path="/Plasticbackspray" element={<Plasticbackspray />} />
        <Route path="/Palletinjectonmol" element={<Palletinjectonmol />} />
        <Route path="/Ledbulmachi" element={<Ledbulmachi />} />
        <Route path="/Plasticstorbox" element={<Plasticstorbox />} />
        {/* Cavitypetpreforms */}
        <Route path="/Cavitypetprefor" element={<Cavitypetprefor />} />
        {/* Choosepetprefor */}
        <Route path="/Choosepetprefo" element={<Choosepetprefo />} />
        {/* Thecommontypet */}
        <Route path="/Thecommontyp" element={<Thecommontyp />} />
        {/* Gallonbottlecaps */}
        <Route path="/Gallonbottleca" element={<Gallonbottleca />} />
        {/* InjePlasticbottlecaps */}
        <Route path="/InjePlasticbottlec" element={<InjePlasticbottlec />} />
        {/* Chooseplasticbottleca */}
        <Route path="/Chooseplasticb" element={<Chooseplasticb />} />
        {/* Howplasticfliptop */}
        <Route path="/Howplasticflipt" element={<Howplasticflipt />} />
        {/* Plasticbottlehandle */}
        <Route path="/Plasticbottlehand" element={<Plasticbottlehand />} />
        {/* Startanledbulb */}
        <Route path="/Startanledbu" element={<Startanledbu />} />
        {/* Commonshapesbulbs */}
        <Route path="/Commonshapesbul" element={<Commonshapesbul />} />
        {/* Materialsledlight */}
        <Route path="/Mat-erialsledlig" element={<Materialsledlig />} />
        {/* Rightplasticpallet */}
        <Route path="/Rig-htplasticpal" element={<Rightplasticpal />} />
        {/* Whatstandardsplastic */}
        <Route path="/What-standardspla" element={<Whatstandardspla />} />
        {/* Commontypesplasticpallets */}
        <Route path="/Com-montypesplasticpa" element={<Commontypesplasticpa />} />
        {/* Commonmanufacturing */}
        <Route path="/Comm-onmanufact" element={<Commonmanufact />} />
        {/* Advantagesplastic */}
        <Route path="/Ad-vantagesps" element={<Advantagesps />} />
        {/* Thinwalleddisposabl */}
        <Route path="/Thi-nwalleddisp" element={<Thinwalleddisp />} />
        {/* Mixedplasticbuckets */}
        <Route path="/Mix-edplasticbuc" element={<Mixedplasticbuc />} />
        {/* Pvcmaterialproducts */}
        <Route path="/Pv-cmaterialpro" element={<Pvcmaterialpro />} />
        {/* Extrusionblowmoldings */}
        <Route path="/Ext-rusionblowmol" element={<Extrusionblowmol />} />
        {/* Moldingexhibition */}
        <Route path="/Mol-dingexhibit" element={<Moldingexhibit />} />
        <Route path="/Contacts" element={<Contacts />} />

      </Routes>
      
       <Footer /> 
    </Router>
    
  );
}
export default App;
